<div class="layout-auto-1">
  <div></div>
  <div class="content md3-surface">
    <div class="layout-list-quickfilter md3-card-on-surface">
      <!-- Search Header -->
      <exg-search-bar (Search)="reportTable.search($event)" [placeholder]="getRessource('SearchHolder')"
                      class="span-layout">
        <ng-template #rightTemplate>
          <i (click)="reportTable.loadData()" class="search-action fal fa-sync"></i>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
	            <i class="search-action fa-filter"
	               [class.fas]="appSvc.metaInfo.uiFilterAktiv(reportTable.uiFilter, 1).length > 0"
	               [class.fal]="appSvc.metaInfo.uiFilterAktiv(reportTable.uiFilter, 1).length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCreportTableFilterControl
                              (onActivateFilter)="reportTable.pageChanged(1);popup.close()"
                              [MetaInfo]="reportTable.MetaInfo"
                              [showFilter]="true" [uiFilter]="reportTable.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="reportTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-sort-alt"
                 [class.fas]="appSvc.metaInfo.uiSortAktiv(reportTable.uiSort).length > 0"
                 [class.fal]="appSvc.metaInfo.uiSortAktiv(reportTable.uiSort).length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCreportTableSortControl
                              (onActivateFilter)="reportTable.pageChanged(1);popup.close()"
                              [MetaInfo]="reportTable.MetaInfo"
                              [showSort]="true" [uiFilter]="reportTable.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="reportTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fa-binoculars"
                 [class.fas]="appSvc.metaInfo.uiFilterAktiv(reportTable.uiFilter, 2).length > 0"
                 [class.fal]="appSvc.metaInfo.uiFilterAktiv(reportTable.uiFilter, 2).length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCreportTableSearchControl
                              (onActivateFilter)="reportTable.pageChanged(1);popup.close()"
                              [MetaInfo]="reportTable.MetaInfo"
                              [showSearch]="true" [uiFilter]="reportTable.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="reportTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <i class="search-action fal fa-gears"
             [class.disabled]="!reportTable.newV2Table"
             (click)="openTableSettings($event)">
          </i>
          <exg-table-settings #tableDefinitionSettings
                              [tableDef]="reportTable.tableDefinition"
                              [metaInfo]="reportTable.MetaInfo"
                              localStorageID="reportTable">
          </exg-table-settings>
          <i class="search-action fa-table"
             (click)="reportTable.newV2Table = !reportTable.newV2Table;"
             [class.fas]="reportTable.newV2Table"
             [class.fal]="!reportTable.newV2Table">
          </i>
        </ng-template>
      </exg-search-bar>
      <div class="content">
        <ng-container *ngIf="!reportTable.newV2Table">
          <exg-data-table #VCreportTable (ItemSelect)="reportTable.selectedRow"

                        (RowChange)="reportTable.selectionChanged($event)" [allowSingleSelection]="true"
                        [displayState]="reportTable.state"
                        [rowSource]="reportTable.data"
                        containerClass="grid cols-20"
                        [selectKey]="reportTable.selectKey"
                        (RowDblClick)="reportTable.dblClick($event)">
          <ng-template #headerTemplate>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('Vorgang', 'vorgNr')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')}}</strong></p>
            </div>
            <div>
              <p><strong>{{enumSvc.getFieldCaption('FragebogenAusgefuellt', 'fbaStatus')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('FragebogenAusgefuellt', 'fbaName')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('FragebogenAusgefuellt', 'fbaVersion')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('Auftrag', 'au_oeID_Auftraggeber')}}</strong></p>
            </div>
            <div class="span-3">
              <p><strong>{{enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')}}</strong></p>
              <p>
                <strong>{{enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')}}</strong>
              </p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('Vorgang', 'vorg_enmIdent_VorgangTyp')}}</strong></p>
              <p><strong>
                {{enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')}}
                ({{enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')}})</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('Vorgang', 'vorgBearbeiter')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('All', '%CRU')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('All', '%CRD')}}</strong></p>
            </div>
            <div class="span-2">
              <p><strong>{{enumSvc.getFieldCaption('All', '%LCU')}}</strong></p>
              <p><strong>{{enumSvc.getFieldCaption('All', '%LCD')}}</strong></p>
            </div>

          </ng-template>
          <ng-template #rowTemplate let-row>
            <div class="span-2">
              <p>{{row.vorgNr}}</p>
              <p>{{row.aueSchadenNr}}</p>
            </div>
            <div class="">
              <p>{{enumSvc.getEnumerationText(row.fbaFragebogenAusgefuelltStatus_enmName,row.fbaFragebogenAusgefuelltStatus_enmIdent)}}</p>
            </div>
            <div class="span-2">
              <p>{{row.fbaName || '-'}}</p>
            </div>
            <div class="span-2">
              <p>{{row.fbaVersion || '-'}}</p>
            </div>
            <div class="span-2">
              <p>{{row.auAuftraggeber}}</p>
            </div>
            <div class="span-3">
              <p>{{row.aueVersicherungsnehmer}}</p>
              <p>{{row.aueSchadenOrt || '-'}}</p>
            </div>
            <div class="span-2">
              <p>
                {{enumSvc.getEnumerationText(row['au_enmName_AuftragTyp'], row['au_enmIdent_AuftragTyp']) || '-'}} |
                {{enumSvc.getEnumerationText(row['vorg_enmName_VorgangTyp'], row['vorg_enmIdent_VorgangTyp']) || '-'}}
              </p>
              <p>
              {{enumSvc.getEnumerationText(row['aue_enmName_SchadenArt'], row['aue_enmIdent_SchadenArt']) || '-'}}
              ({{enumSvc.getEnumerationText(row['aue_enmName_Versicherungsart'], row['aue_enmIdent_Versicherungsart'])}} || '-')
              </p>
            </div>
            <div class="span-2">
              <p>{{row.vorgBearbeiter  || '-'}}</p>
            </div>
            <div class="span-2">
              <p>{{row.fbaCRU}}</p>
              <p>{{row.fbaCRD | excDate:'Globals.DateTimeFormatShort' }}</p>
            </div>
            <div class="span-2">
              <p>{{row.fbaLCU}}</p>
              <p>{{row.fbaLCD | excDate:'Globals.DateTimeFormatShort' }}</p>
            </div>
          </ng-template>
        </exg-data-table>
        </ng-container>
        <ng-container *ngIf="reportTable.newV2Table">
	        <exg-table #VCreportTableV2
	                   (RowDblClick)="reportTable.dblClick($event)"
	                   (RowChange)="reportTable.selectionChanged($event)"
	                   (FilterActivation)="reportTable.loadData()"
	                   [selectKey]="reportTable.selectKey"
	                   [rowSource]="reportTable.data"
	                   [tableDef]="reportTable.tableDefinition"
	                   [distinctTableName]="'Reports'"
	                   [metaInfo]="reportTable.MetaInfo"
	                   [displayState]="reportTable.state"
	                   class="content"
	                   [allowMultiSelection]="false"
	                   [allowSingleSelection]="true"
	                   (loadDistinct)="reportTable.getDistinctData($event)"
	                   [distinctData]="reportTable.distinctData">
	        </exg-table>
        </ng-container>
      </div>
      <div class="search-quickfilter">
        <i class="search-filter-action fal fa-chevron-right"
           (click)="openReference()"
           [tooltip]="getRessource('openWorkspace')" flow="left"
           [class.disabled]="reportTable.isLoading">
        </i>
      </div>
      <exg-pager (PageChange)="reportTable.pageChanged($event)" *ngIf="!init"
                 [pagingSource]="reportTable.paging"
                 class="span-layout">
        <ng-template #leftTemplate>
        </ng-template>
        <ng-template #rightTemplate>
          <div class="app-pager-chips">
            <app-exg-filter-chips #VCFilterChips
                                  [inputDataTable]="reportTable"
                                  [VCFilterControl]="{ VCFilter: VCreportTableFilterControl, VCSearch: VCreportTableSearchControl, VCSort: VCreportTableSortControl}">
            </app-exg-filter-chips>
          </div>
        </ng-template>
      </exg-pager>
    </div>
  </div>
</div>
